var map = {
	"./brands-collections-results.de-CH.json": 1288,
	"./brands-collections-results.de-DE.json": 1289,
	"./brands-collections-results.en-CA.json": 1290,
	"./brands-collections-results.en-GB.json": 1291,
	"./brands-collections-results.en-IN.json": 1292,
	"./brands-collections-results.en-ME.json": 1293,
	"./brands-collections-results.en-US.json": 1294,
	"./brands-collections-results.es-EM.json": 1295,
	"./brands-collections-results.es-ES.json": 1296,
	"./brands-collections-results.fr-BE.json": 1297,
	"./brands-collections-results.fr-CA.json": 1298,
	"./brands-collections-results.fr-CH.json": 1299,
	"./brands-collections-results.nl-BE.json": 1300,
	"./brands-collections-results.nl-NL.json": 1301,
	"./brands-collections-results.pl-PL.json": 1302,
	"./brands-collections-results.pt-BR.json": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1287;